// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"ef5bd142","457":"49e20829","672":"77fd1541","710":"ef5bd142","720":"6a2b7fb4","732":"31d6cfe0","940":"db4fab1b"}[chunkId] + ".chunk.css";
};